// src/utils/snap.js
export async function sha256Hex(str) {
  const enc = new TextEncoder().encode(String(str || ""));
  const buf = await crypto.subtle.digest("SHA-256", enc);
  return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2,"0")).join("");
}

export function normalizeEmail(email) {
  if (!email) return "";
  return String(email).trim().toLowerCase();
}

export function normalizePhone(phone, countryCode = "SA") {
  if (!phone) return "";
  let p = String(phone).trim();
  const map = { "٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9" };
  p = p.replace(/[٠-٩]/g, (d) => map[d] ?? d);
  p = p.replace(/\D+/g, "");
  if (countryCode === "SA" && !p.startsWith("966")) {
    if (p.startsWith("0")) p = p.slice(1);
    p = "966" + p;
  }
  return p;
}

export async function snapSetUserData({ email, phone, countryCode = "SA" } = {}) {
  try {
    const payload = {};
    const e = normalizeEmail(email);
    const p = normalizePhone(phone, countryCode);
    if (e) payload.email = await sha256Hex(e);
    if (p) payload.phone_number = await sha256Hex(p);
    if (Object.keys(payload).length && window.snaptr) {
      window.snaptr("setUserData", payload);
    }
  } catch {
    // تجاهل الخطأ لو crypto.subtle غير متاح (بيئة غير آمنة)
  }
}

/* Events ready-to-use */
export function trackPageView() {
  if (window.snaptr) window.snaptr("track", "PAGE_VIEW");
}
export function trackFormView() {
  if (window.snaptr) window.snaptr("track", "CUSTOM_EVENT_1", { event_name: "form_view" });
}
export function trackFormStart() {
  if (window.snaptr) window.snaptr("track", "CUSTOM_EVENT_1", { event_name: "form_start" });
}
export function trackSignUp() {
  if (window.snaptr) window.snaptr("track", "SIGN_UP");
}
export function trackClickWhatsapp() {
  if (window.snaptr) window.snaptr("track", "CUSTOM_EVENT_1", { event_name: "click_whatsapp" });
}
export function trackClickCall() {
  if (window.snaptr) window.snaptr("track", "CUSTOM_EVENT_1", { event_name: "click_call" });
}

// (اختياري) شراء فعلي لو موجود تدفق شراء حقيقي
export function trackPurchase({ value, currency = "SAR", items = [] } = {}) {
  const params = {};
  if (typeof value === "number") params.price = Number(value.toFixed(2));
  if (currency) params.currency = String(currency).toUpperCase();
  if (Array.isArray(items) && items.length) {
    params.item_ids    = items.map(i => i.id);
    params.item_prices = items.map(i => Number((i.price ?? 0)));
    params.quantities  = items.map(i => Number(i.qty ?? 1));
  }
  if (window.snaptr) window.snaptr("track", "PURCHASE", params);
}
